import React from 'react';
import { Route } from '@americanexpress/one-app-router';
import Welcome from './pages/Welcome';
import ErrorScreen from './pages/ErrorScreen';
import Feedback from './pages/Feedback';
import PaymentConfirmation from './pages/PaymentConfirmation';
import Finish from './pages/Finish';
import PayYourBill from './pages/PayYourBill';
import Loader from './pages/Loader';
import BalancePage from './pages/BalancePage';

const childRoutes = () => [
  <Route key="/" path="/" component={Loader} />,
  <Route key="/welcome" path="/welcome" component={Welcome} />,
  <Route key="/payyourbill" path="/payyourbill" component={PayYourBill} />,
  <Route key="/message" path="/message" component={ErrorScreen} />,
  <Route key="/feedback" path="/feedback" component={Feedback} />,
  <Route key="/paymentconfirmation" path="/paymentconfirmation" component={PaymentConfirmation} />,
  <Route key="/finish" path="/finish" component={Finish} />,
  <Route key="/balance" path="/balance" component={BalancePage} />,
];
export default childRoutes;
